export default __webpack_public_path__ + "static/media/prologue-clock.0402622c.png";